var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-footer",
    { staticClass: "pa-3", attrs: { app: "", inset: "", absolute: "" } },
    [
      _c("span", { attrs: { id: "sb-version-num" } }, [
        _vm._v(
          _vm._s(
            _vm.commitHash !== ""
              ? "v" + _vm.version + " (" + _vm.commitHash.substr(0, 8) + ")"
              : "v" + _vm.version
          )
        )
      ]),
      _vm._v(" "),
      _c("v-spacer"),
      _vm._v(" "),
      _c(
        "a",
        { attrs: { href: "https://www.sphereco.com/", target: "_blank" } },
        [_vm._v("\n    SPHERE Technology Solutions\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }